import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => {
  const reduce = useReducedMotion();
  if (reduce) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export const StaggerLines = ({ lines, className = "", lineClass = "" }) => {
  const reduce = useReducedMotion();
  if (reduce) {
    return (
      <span className={className}>
        {lines.map((line, i) => (
          <span key={i} className={`block ${lineClass}`}>{line}</span>
        ))}
      </span>
    );
  }
  const container = {
    hidden: {},
    show: { transition: { staggerChildren: 0.12, delayChildren: 0.15 } },
  };
  const child = {
    hidden: { y: "110%" },
    show: { y: "0%", transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] } },
  };
  return (
    <motion.span className={className} variants={container} initial="hidden" animate="show">
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span className={`block ${lineClass}`} variants={child}>
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};
